import React from 'react'
import { cn } from '@/utils/helpers'

interface SelectOption {
  value: string
  label: string
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value'> {
  label?: string
  options: SelectOption[]
  error?: string | undefined
  value?: string
  onChange?: ((value: string) => void) | React.ChangeEventHandler<HTMLSelectElement>
}

export const Select: React.FC<SelectProps> = ({
  label,
  options,
  error,
  className,
  value,
  onChange,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      if (props.name) {
        (onChange as React.ChangeEventHandler<HTMLSelectElement>)(e)
      } else {
        (onChange as (value: string) => void)(e.target.value)
      }
    }
  }

  return (
    <div className="w-full">
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-secondary-700">
          {label}
        </label>
      )}
      <select
        className={cn(
          'w-full rounded-lg border border-secondary-300 bg-white px-3 py-2.5',
          'text-secondary-900',
          'transition-colors duration-200',
          'focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20',
          'disabled:bg-secondary-50 disabled:cursor-not-allowed',
          error && 'border-error focus:border-error focus:ring-error/20',
          className
        )}
        value={value}
        onChange={handleChange}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1.5 text-sm text-error">{error}</p>}
    </div>
  )
}
